module.exports = __webpack_public_path__ + "img/4_2.36d86fa4.png";